import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import cytoscape from 'cytoscape';
import contextMenus from 'cytoscape-context-menus';
import elk from 'cytoscape-elk';

import { AppComponent } from '@connect-services/client/app/app.component';
import { appConfig } from '@connect-services/client/app/app.config';
import { environment } from '@connect-services/client/environments/environment';
import { EnvironmentNameEnum } from '@shared/client/models/environment.interface';

Sentry.init({
    dsn: environment.sentryUrl,
    enabled: environment.env !== EnvironmentNameEnum.DEV,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: ['https://app.connect-services.app', 'https://app.staging.connect-services.app'],
    tracesSampleRate: 0.05,
});

// eslint-disable-next-line no-console
bootstrapApplication(AppComponent, appConfig).catch((error: unknown) => console.error(error));

cytoscape.use(elk);
cytoscape.use(contextMenus);
